import { getShouldDisplayFees } from '../getShouldDisplayFees/getShouldDisplayFees';
import { getShouldDisplayTaxes } from '../getShouldDisplayTaxes/getShouldDisplayTaxes';

interface GetPriceDisplayStatus {
    regionCode?: string;
    isPriceUpfrontEnabled: boolean;
}

export type PriceDisplayStatus = 'fees' | 'taxes' | 'both' | 'none';

export const getPriceDisplayStatus = ({
    regionCode = '',
    isPriceUpfrontEnabled = false,
}: GetPriceDisplayStatus): PriceDisplayStatus => {
    if (isPriceUpfrontEnabled) {
        return 'none';
    }

    const shouldDisplayFees = getShouldDisplayFees({ regionCode });
    const shouldDisplayTaxes = getShouldDisplayTaxes({ regionCode });

    if (shouldDisplayFees && shouldDisplayTaxes) {
        return 'both';
    }

    if (shouldDisplayFees) {
        return 'fees';
    }

    if (shouldDisplayTaxes) {
        return 'taxes';
    }

    return 'none';
};
